import {
  setBlog,
  setBlogTotalPages,
  setFetchLoading,
  setGalleryTotalPage,
  setGallerydata,
  setBlogLoadingGetData,
  setRBBlog,
} from "../../redux/actions/Blog";
import appApi from "../../utils/AppApi";
import errorHandler from "../../utils/ErrorHandler";

const BlogRequests = {
  getAllblogs: (type, page) => {
    return (dispatch) => {
      dispatch(setBlogLoadingGetData(true));
      if (page === 1) {
        dispatch(setFetchLoading(true));
      }
      try {
        appApi
          .get(`/blog/getall?searchString=${type}&page=${page}&limit=${3}`)
          .then(({ data }) => {
            dispatch(setBlog(data.blogs.docs));
            dispatch(setBlogTotalPages(data.blogs.totalPages));
            dispatch(setFetchLoading(false));
            dispatch(setBlogLoadingGetData(false));
          });
      } catch (error) {
        errorHandler(error);
        dispatch(setFetchLoading(false));
        dispatch(setBlogLoadingGetData(false));
      }
    };
  },
  getBlogsByTag: (tag, page) => {
    return (dispatch) => {
      dispatch(setBlogLoadingGetData(true));
      if (page === 1) {
        dispatch(setFetchLoading(true));
      }
      try {
        appApi
          .get(`/blog/getallbytag?searchString=${tag}&page=${page}&limit=${3}`)
          .then(({ data }) => {
            dispatch(setRBBlog(data.blogs.docs));
            dispatch(setBlogTotalPages(data.blogs.totalPages));
            dispatch(setFetchLoading(false));
            dispatch(setBlogLoadingGetData(false));
          });
      } catch (error) {
        errorHandler(error);
        dispatch(setFetchLoading(false));
        dispatch(setBlogLoadingGetData(false));
      }
    };
  },
  getGalleryMedia: (page, limit) => {
    return (dispatch) => {
      dispatch(setFetchLoading(true));
      try {
        appApi
          .get(`/gallery/getall?page=${page}&limit=${limit}`)
          .then(({ data }) => {
            dispatch(setGallerydata(data.docs));
            dispatch(setFetchLoading(false));
            dispatch(setGalleryTotalPage(data.totalPages));
          });
      } catch (error) {
        errorHandler(error);
        dispatch(setFetchLoading(false));
      }
    };
  },
};

export default BlogRequests;
